<template>
    <div class="plannedActual-hover" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="content" style="font-size:11px;" v-if="employee != null">


            <div v-if="mode == 'soll'">
                <div style="border-bottom: 2px solid black; padding-bottom: 4px; margin-bottom:6px;">
                    <div class="left_column">
                        {{ $t('workBalance.summary.target') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].sumSollWorkTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>

                
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.view.deltaPreviousMonth') }}
                    </div>
                    <div class="right_column">
                        {{ (($parent.employeePlannedActual[employee.id].deltaWorkTime)/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.view.contractTarget') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].sollWorkTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
            </div>



            <div v-if="mode == 'productive'">
                <div style="border-bottom: 2px solid black; padding-bottom: 4px; margin-bottom:6px;">
                    <div class="left_column">
                        {{ $t('store.structure.productive') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].sumWorkTimeProduktiv/1000/3600).toFixed(2) }} h
                    </div>
                </div>

                
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.view.planRest') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].planTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.view.hoursLogged') }}<br/>
                        <small class="text-muted">{{ $t('roster.view.confirmedHours') }}</small><br/>
                        <small class="text-muted">{{ $t('roster.view.unConfirmedHours') }}</small>
                    </div>
                    <div class="right_column"><br/>
                        {{ (($parent.employeePlannedActual[employee.id].istConfirmedTime/1000/3600) + ($parent.employeePlannedActual[employee.id].istUnconfirmedTime/1000/3600)).toFixed(2) }} h<br/>
                        <small class="text-muted">{{ ($parent.employeePlannedActual[employee.id].istConfirmedTime/1000/3600).toFixed(2) }} h</small><br/>
                        <small class="text-muted">{{ ($parent.employeePlannedActual[employee.id].istUnconfirmedTime/1000/3600).toFixed(2) }} h</small>
                    </div>
                </div>
            </div>


            <div v-if="mode == 'unproductive'">
                <div style="border-bottom: 2px solid black; padding-bottom: 4px; margin-bottom:6px;">
                    <div class="left_column">
                        {{ $t('roster.view.unproductive') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].sumWorkTimeUnproduktiv/1000/3600).toFixed(2) }} h
                    </div>
                </div>

                
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.summary.vacation') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].urlaub/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.summary.sickLeave') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].krankenstand/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.summary.nursingLeave') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].pflegeurlaub/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.summary.trainee') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].ausbildung/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.summary.sickPay') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].lfz/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.main.other') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].miscWorkTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.payroll.holidayCompensation') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].ftaTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
            </div>


            <div v-if="mode == 'federalholiday'">
                <div style="border-bottom: 2px solid black; padding-bottom: 4px; margin-bottom:6px;">
                    <div class="left_column">
                        {{ $t('roster.comp.holidayHours') }}
                    </div>
                    <div class="right_column">
                    </div>
                </div>

                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.view.currentMonth') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].ftPlanTime/1000/3600 + $parent.employeePlannedActual[employee.id].ftIstConfirmedTime/1000/3600 + $parent.employeePlannedActual[employee.id].ftIstUnconfirmedTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('workBalance.payroll.holidayCompensation') }}
                    </div>
                    <div class="right_column">
                        - {{ ($parent.employeePlannedActual[employee.id].ftaTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        {{ $t('roster.view.carryOver') }}
                    </div>
                    <div class="right_column">
                        {{ ($parent.employeePlannedActual[employee.id].deltaFtWorkTime/1000/3600).toFixed(2) }} h
                    </div>
                </div>
                <div style="padding-bottom: 4px; margin-bottom:2px;">
                    <div class="left_column">
                        <b>{{ $t('roster.view.holidayBalanceAccumulated') }}</b>
                    </div>
                    <div class="right_column">
                        <b>{{ ($parent.employeePlannedActual[employee.id].sumFtWorkTime/1000/3600 + $parent.employeePlannedActual[employee.id].deltaFtWorkTime/1000/3600).toFixed(2) }} h</b>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
    export default {
        name: 'plannedActualhover',
        components: {
        },
        data(){
            return{
                toggled: false,
                elRelative: null,
                events: [],
                posx: 0,
                posy: 0,
                employee: null,
                mode: 0,
                planRange: "",
                istRange: "",
            }
        },
        created () {
        },
        destroyed(){
        },
        methods: {
            Close(){
                if($(window.mouse.element).closest('.plannedActual-hover').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(employee, mode, elRelative){
                this.toggled = true;
                this.employee = employee;
                this.mode = mode;

                if(elRelative){
                    this.elRelative = elRelative
                    this.Reposition();
                }
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    view.posx = box.left + box.width + 5;
                    view.posy = box.top + 24;
                    view.$forceUpdate();
                });
            },
        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .plannedActual-hover{
        position:fixed;
        display:inline-block;
        max-height: 520px;
        width: 233px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 15px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

    .left_column {
        display:inline-block; width: 150px; text-align:left;
    }
    .right_column {
        display:inline-block; width: 50px; text-align:right;
    }

</style>
